export const RequestType = "Request Contact Update";
